import { render, staticRenderFns } from "./DecommissionChannelGrid.vue?vue&type=template&id=36fbc0e0&scoped=true&"
import script from "./DecommissionChannelGrid.vue?vue&type=script&lang=js&"
export * from "./DecommissionChannelGrid.vue?vue&type=script&lang=js&"
import style0 from "./DecommissionChannelGrid.vue?vue&type=style&index=0&id=36fbc0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbc0e0",
  null
  
)

export default component.exports